import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    cardContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        height: 100
    },
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    cardContent: {
        flexDirection: "row",
        alignItems: "center"
    }
});

export default stylesheet;
